module.exports = __webpack_public_path__ + "img/sousuo.add4819d.svg";